var map = {
	"./Landing": "./src/pages/landing/Landing.tsx",
	"./Landing.module.scss": "./src/pages/landing/Landing.module.scss",
	"./Landing.tsx": "./src/pages/landing/Landing.tsx",
	"./assets/images/GLOBAL SCALE.png": "./src/pages/landing/assets/images/GLOBAL SCALE.png",
	"./assets/images/OASIS RETAIL 1.jpg": "./src/pages/landing/assets/images/OASIS RETAIL 1.jpg",
	"./assets/images/OASIS RETAIL 2.jpg": "./src/pages/landing/assets/images/OASIS RETAIL 2.jpg",
	"./assets/images/OASIS RETAIL 3.jpg": "./src/pages/landing/assets/images/OASIS RETAIL 3.jpg",
	"./assets/images/OASIS RETAIL 4.jpg": "./src/pages/landing/assets/images/OASIS RETAIL 4.jpg",
	"./assets/images/OASIS RETAIL 5.jpg": "./src/pages/landing/assets/images/OASIS RETAIL 5.jpg",
	"./assets/images/fantasticos.png": "./src/pages/landing/assets/images/fantasticos.png",
	"./constants/SubmissionData": "./src/pages/landing/constants/SubmissionData.tsx",
	"./constants/SubmissionData.tsx": "./src/pages/landing/constants/SubmissionData.tsx",
	"./nmaModalsData": "./src/pages/landing/nmaModalsData.ts",
	"./nmaModalsData.ts": "./src/pages/landing/nmaModalsData.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/pages/landing sync recursive ^\\.\\/.*$";